import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class UtilityMeterTableHeader extends Component
{
  static Layout = [
      { column: "utility", width: 2 },
      { column: "serialNumber", width: 3, name: "Serial Number" },
      { column: "reference" , width: 3, name:"Supplier Reference" },
      { column: "amr" },
      { column: "meterType", width: 2, name: "Meter Type" },
      { column: "active", width: 2 },
      { column: "empty", width: 2 }
  ];

  render() {
      return (
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={UtilityMeterTableHeader.Layout}/>
      )
  }
}